<template>

    <div v-if="position < 4" class="swing">

        <vue-swing :config="config"
                   class="card-inherit"
                   @dragmove="dragmove"
                   @throwoutleft="emitEvent('throwoutleft', $listeners)"
                   @throwoutright="emitEvent('throwoutright', $listeners)"
                   @throwoutup="emitEvent('throwoutup', $listeners)"
                   @dragend="dragend"
                   v-if="isSwipingcard(card)">

            <card-template-newsletters  v-if="card.type === 'newsletter'" :card="card" :position="position" :throwDirection="throwDirection" :throwOutConfidence="throwOutConfidence"></card-template-newsletters>

            <card-template-market v-if="card.type === 'market'" :card="card" :position="position"></card-template-market>

        </vue-swing>

        <card-template-newsletters v-if="card.type === 'newsletter' && card.invalidGrant" :card="card" :position="position" @invalidGrant="invalidGrant"></card-template-newsletters>

        <card-template-sharing v-if="card.type === 'sharing'" :card="card" @share="share"></card-template-sharing>

    </div>

</template>

<script>

import Tag from '@/modules/tag'
import VueSwing from 'vue-swing'

import CardTemplateNewsletters from '@/components/newsletters/CardTemplateNewsletters'
import CardTemplateMarket from '@/components/newsletters/CardTemplateMarket'
import CardTemplateSharing from '@/components/newsletters/CardTemplateSharing'


export default {

    name: 'cards',

    components: {CardTemplateMarket, CardTemplateNewsletters, CardTemplateSharing, VueSwing },

    props: {

        card: {
            type: Object,
            default: () => {
            }
        },

        position: {
            type: Number,
            default: 0
        }
    },

    data () {
        return {
            config: {
                throwOutConfidence: (xOffset, yOffset, element) => {

                    if (Math.abs(xOffset) > yOffset) {

                        const xConfidence = Math.min(Math.abs(xOffset) / element.offsetWidth, 1)
                        const yConfidence = Math.min(Math.abs(yOffset) / element.offsetHeight, 1)
                        const result = Math.max(xConfidence, yConfidence)
                        return result > 0.5 ? 1 : result
                    }

                    return 0
                },
                allowedDirections: [ VueSwing.Direction.DOWN, VueSwing.Direction.RIGHT, VueSwing.Direction.UP, VueSwing.Direction.LEFT ]
            },
            throwOutConfidence: 0,
            throwDirection: ''
        }
    },

    methods: {

        share () {

            Tag.clickGA(this, 'sharing')

            this.$emit('share')

        },

        isSwipingcard(card) {

            return !card.invalidGrant && card.type !== 'sharing'

        },

        emitEvent (event) {

            switch (event) {
                case 'throwoutleft':
                case 'throwoutright':
                case 'throwoutup':

                    if (!this.card.invalidGrant && this.position === 1) {
                        this.$emit(event)
                    }
                    break
            }
        },

        invalidGrant(email) {
            this.$emit('invalidGrant', email)
        },

        dragmove (value) {
            const directToString = String(value.throwDirection)

            this.throwOutConfidence = value.throwOutConfidence

            switch (directToString) {
                case 'Symbol(UP)':
                    this.throwDirection = 'up'
                    break
                case 'Symbol(LEFT)':
                    this.throwDirection = 'left'
                    break
                case 'Symbol(RIGHT)':
                    this.throwDirection = 'right'
                    break
                case 'Symbol(DOWN)':
                    this.throwDirection = 'down'
                    break
                default:
                    this.throwDirection = ''
            }

        },

        dragend () {

            this.throwDirection = ''
            this.throwOutConfidence = 0

        }
    }
}

</script>

<style scoped lang="scss">

    .swing {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
    }

    .card-inherit {
        height: inherit;
        display: flex;
    }

</style>
